{
  "primary": {
    "primary-50": "#fff6fd",
    "primary-100": "#ffeef9",
    "primary-150": "#fee6f6",
    "primary-200": "#fddef2",
    "primary-250": "#fbd4ef",
    "primary-300": "#f9c9eb",
    "primary-350": "#f7bfe9",
    "primary-400": "#f4b5e6",
    "primary-450": "#ef96da",
    "primary-500": "#e975cc",
    "primary-550": "#e150be",
    "primary-600": "#d912ae",
    "primary-650": "#bb0c94",
    "primary-700": "#9d067b",
    "primary-750": "#810264",
    "primary-800": "#65004d",
    "primary-850": "#4d003a",
    "primary-900": "#370028",
    "primary-950": "#220017"
  },
  "accent": {
    "accent-50": "#f0fbff",
    "accent-100": "#e4f6ff",
    "accent-150": "#d7f2fe",
    "accent-200": "#cbedfd",
    "accent-250": "#bceafe",
    "accent-300": "#ade7ff",
    "accent-350": "#9de3ff",
    "accent-400": "#8ce0ff",
    "accent-450": "#5ac9ff",
    "accent-500": "#26aeff",
    "accent-550": "#008fff",
    "accent-600": "#146cfd",
    "accent-650": "#0c5ad4",
    "accent-700": "#0548ad",
    "accent-750": "#023688",
    "accent-800": "#002664",
    "accent-850": "#001a4d",
    "accent-900": "#001037",
    "accent-950": "#000622"
  },
  "grey": {
    "grey-50": "#fafafa",
    "grey-100": "#f5f5f5",
    "grey-150": "#f0f0f0",
    "grey-200": "#ebebeb",
    "grey-250": "#e3e5e6",
    "grey-300": "#dcdfe0",
    "grey-350": "#d4d9db",
    "grey-400": "#cdd3d6",
    "grey-450": "#aab0b4",
    "grey-500": "#888f92",
    "grey-550": "#686f72",
    "grey-600": "#495054",
    "grey-650": "#3f4549",
    "grey-700": "#353b3f",
    "grey-750": "#2b3135",
    "grey-800": "#22272b",
    "grey-850": "#181c1f",
    "grey-900": "#0e1113",
    "grey-950": "#050709"
  }
}
